export default __webpack_public_path__ + "static/media/rush.e4ffaebe.png";